import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";

import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Schedule } from "./routes/Schedule";
import { Error500 } from "./components/error/500";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      errorElement: <Error500 />,
      children: [
        {
          index: true,
          element: <Schedule />,
        },
      ],
    },
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
    },
  }
);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  // <React.StrictMode>
  <RouterProvider router={router} />
  // </React.StrictMode>
);
